import React from 'react';

import svg from './assets/icons-16-pin.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconPin = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-schedule" />
);
